import { render, staticRenderFns } from "./RecManuscript.vue?vue&type=template&id=433c878a&scoped=true"
import script from "./RecManuscript.vue?vue&type=script&lang=js"
export * from "./RecManuscript.vue?vue&type=script&lang=js"
import style0 from "./RecManuscript.vue?vue&type=style&index=0&id=433c878a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433c878a",
  null
  
)

export default component.exports